import { AppForms, React } from '@/app'
import { contributeStore } from '@/stores'
import { modal } from '@codeleap/modals'
import { TypeGuards } from '@codeleap/types'
import { Button, View } from '@/components'
import { ContributeForm, useContributeForm } from './Form'

type ContributeModalProps = {
  formInitialState?: AppForms.CommunityFormValue
}

type ContributeModalResult = AppForms.CommunityFormValue

export const ContributeModal = modal<ContributeModalProps, ContributeModalResult>({ id: 'contribute-modal' }).content(props => {
  const { formInitialState, request } = props

  const { prompt } = contributeStore.state.use()

  const isPrompt = TypeGuards.isNumber(prompt?.id)

  const form = useContributeForm({ prompt: isPrompt, required: true, initialState: formInitialState })

  const onClose = () => {
    request.resolve(formInitialState)
  }

  const onAdd = () => {
    request.resolve(form?.values)
  }

  const canSave = form?.isValid

  return <>
    <ContributeForm
      form={form}
      prompt={isPrompt}
      title={prompt?.title}
      showGuidelines={false}
    />

    <View variants={['gap:2', 'row']}>
      <Button
        debugName=''
        text='Cancel'
        variants={['outline', 'large', 'fullWidth']}
        onPress={onClose}
      />
      <Button
        debugName=''
        text='Add'
        disabled={!canSave}
        variants={['large', 'fullWidth']}
        onPress={onAdd}
      />
    </View>
  </>
}).props({ showClose: false })